var React = require('react');
var ReactRouter = require('react-router');
var ReactDOM = require('react-dom');
var Link = ReactRouter.Link;
var Reflux = require('reflux');
var ScreenWid = require('./stores/screen-wid-store');
var Shopify = require('./shopify');
var TopBigImg = require('./header-full');
var TopBigImgM = require('./header-full-m');
var ProductRow = require('./product-row');
var Utils = require('./utils');
var ScrollToTop = require('./scroll-to-top');


var CollectionSegment = React.createClass({

  unmounted: false,

  getInitialState: function() {
    return { imgSource: "",
             lead: "",
             collection: "" }
  },

  componentDidMount: function() {
    Shopify.getCollection(this.props.collection, this.collectionGot);
    Shopify.getCollectionInfo(this.props.collection, this.collectionInfoGot);
    setTimeout(function() { jQuery(window).scroll(); }, 300);
  },

  componentWillUnmount: function() {
    this.unmounted = true;
  },

  collectionGot: function(collection) {
    if (this.unmounted) return;

    var forThis = _.filter(collection, function(prod) {
      return prod.tags.indexOf(this.props.gender) >= 0;
    }, this);
    this.refs.prodRow.setProducts(_.take(forThis, 3));
    if("SM" == ScreenWid.width) {
        var viewportWidth = jQuery(window).width();
        var itemWidth = viewportWidth * 0.6;
        
        jQuery('.slides').flexslider({
            selector: '.product-row .product-thumb',
            animation: 'slide',
            slideshowSpeed: 5000,
            directionNav: false,
            animationLoop: true,
            itemWidth: itemWidth ,
            startAt: 1
         }); 

        var margin = viewportWidth * 0.2;
        jQuery('.flex-viewport').css({'margin-left': margin});
        jQuery('.flex-viewport').css({'margin-right': margin});
    }
  },

  collectionInfoGot: function(collectionInfo) {
    if (this.unmounted) return;
    
    var html = Utils.reconstructPost(collectionInfo.description.replace("\n", '').replace("\r", ''),
                                     false);
    var lead = html.getByClass('prefix');

    var bgImg = null;
    if("SM" == ScreenWid.width) {
      bgImg = this.props.imgMobile;
    } else if (collectionInfo.image) {
      bgImg = collectionInfo.image.src;
    }
    if (bgImg) {
      jQuery(ReactDOM.findDOMNode(this.refs.featuredImg)).css('background',
                                                              'url(' + bgImg + ') center bottom no-repeat');
    }
    this.setState({ lead: lead ? lead.innerText : '',
                    imgSource: collectionInfo.image ? collectionInfo.image.src : '',
                    collectionTitle: collectionInfo.title})
  },

  render: function() {
    return <section className={"featured-collection" + (this.props.noFadeIn ? "" : " fade-in")}>
                <div className="for-border">
                    <div ref="featuredImg" className="featured-img">
                    </div>
                    <div className="row">
                        <div className="text-wrap col-xs-10 col-xs-offset-1 col-md-8 col-md-offset-2">
                            <p className="lead">{this.state.lead}</p>
                            <h1>{this.state.collectionTitle}</h1>
                            <Link to={ "/collections/" + this.props.collection + "/" + this.props.gender.toLowerCase() }
                                  className="btn btn-primary">SHOP COLLECTION</Link>
                        </div>
                    </div>
                    <div className="slides-container">
                        <div ref="slides" className="slides">
                            <ProductRow ref="prodRow"
                                        collection={this.props.collection} />
                        </div>
                    </div>
                </div>
          </section>
  }
});

module.exports = React.createClass({

  mixins: [ ScrollToTop, Reflux.ListenerMixin ],

  getInitialState: function() {
    return { menusForCat: null };
  },

  componentDidMount: function() {
    this.scrollToTop('gender-page');
    this.listenTo(ScreenWid, this.onScreenWid);
    this.onScreenWid(null, ScreenWid.width);
    window.addEventListener("scroll", this.onScroll);
    if ('LG' != ScreenWid.width) {
      this.setState({ menusForCat: this.props.menus });
    }
  },

  componentWillUnmount: function() {
    window.removeEventListener("scroll", this.onScroll);
  },

  onScreenWid: function(event, wid) {
    if ("LG" != wid) {
      jQuery(ReactDOM.findDOMNode(this.refs.subNav)).css('display', 'none');
    } else {
      jQuery(ReactDOM.findDOMNode(this.refs.subNav)).css('display', 'block');
    }
    if ("LG" == wid) {
      this.setState({ menusForCat: null });
    } else {
      this.setState({ menusForCat: this.props.menus });
    }
  },

  onScroll: function(event) {
    var navbarHei = jQuery('.navbar').height();
    var subNavY = jQuery(ReactDOM.findDOMNode(this.refs.subNav)).offset().top;

    if (window.scrollY > subNavY - navbarHei - 20) {
      jQuery(ReactDOM.findDOMNode(this.refs.subNavInner)).addClass('sticky-subnav');
    } else {
      jQuery(ReactDOM.findDOMNode(this.refs.subNavInner)).removeClass('sticky-subnav');
    }
  },

  render: function() {

    var i = 0;
    var menus = [<Link to={"/collections/" + this.props.gender.toLowerCase()} >Collections</Link>];

    menus = _.reduce(this.props.menus, function(acc, menu) {
      i++;
      acc.push(<Link to={menu.url} key={this.props.gender + i}>{menu.title}</Link>);
      return acc;
    }.bind(this), menus);

    var promo1 = null, promo2 = null, promo3 = null, promo4 = null, promo5 = null, promo6 = null;
    if (this.props.promo1) {
      promo1 = <CollectionSegment gender={this.props.gender} noFadeIn={true}
                                  collection={this.props.promo1}
                                  imgMobile={this.props.promo1_img} />;
    }
    if (this.props.promo2) {
      promo2 = <CollectionSegment gender={this.props.gender} 
                                  collection={this.props.promo2}
                                  imgMobile={this.props.promo2_img} />;
    }
    if (this.props.promo3) {
      promo3 = <CollectionSegment gender={this.props.gender} 
                                  collection={this.props.promo3}
                                  imgMobile={this.props.promo3_img} />;
    }
    if (this.props.promo4) {
      promo4 = <CollectionSegment gender={this.props.gender} 
                                  collection={this.props.promo4}
                                  imgMobile={this.props.promo4_img} />;
    }
    if (this.props.promo5) {
      promo5 = <CollectionSegment gender={this.props.gender} 
                                  collection={this.props.promo5}
                                  imgMobile={this.props.promo5_img} />;
    }
    if (this.props.promo6) {
      promo6 = <CollectionSegment gender={this.props.gender} 
                                  collection={this.props.promo6}
                                  imgMobile={this.props.promo6_img} />;
    }

    return <div>
            <TopBigImg subHeading="Shop by Category" ref="topBigImg" className="desktop"
                       title={this.props.tbi_title} desc={this.props.tbi_text}
                       btnText={this.props.tbi_btnText} btnLink={this.props.tbi_btnLink}
                       image={this.props.tbi_image}
                       menus={this.state.menusForCat}/>
            <TopBigImgM ref="topBigImgM" gender={this.props.gender} image={this.props.tbi_imageM}
                        menus={this.props.menus}
                        title={"Womens" == this.props.gender ? "SHOP WOMEN'S" : "SHOP MEN'S"} />
            <div className="subnav-wrap" ref="subNav">
                <div className="container"  ref="subNavInner">
                    <nav className="sub-nav">
                        {menus}
                    </nav>
                </div>
            </div>
            <main id="content" className="container" role="main">
                {promo1}
                {promo2}
                {promo3}
                {promo4}
                {promo5}
                {promo6}
            </main>
          </div>
  }
});